import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheckIcon, PenLineIcon, ClockIcon, HelpCircleIcon } from 'lucide-react';
const offerItems = [{
  title: 'eBook PDF Principal',
  subtitle: 'Protocolo de 52 páginas',
  value: '$47.00 USD',
  coverColor: 'bg-blue-700',
  valueColor: 'text-blue-600',
  coverLabel: 'Calmante\nNatural\n24h',
  icon: null,
  coverImage: 'https://images.unsplash.com/photo-1528715471579-d1bcf0ba5e83?w=400&h=600&fit=crop'
}, {
  title: 'Listas de Acción',
  subtitle: '5 guías paso a paso',
  value: '$17.00 USD',
  coverColor: 'bg-emerald-600',
  valueColor: 'text-emerald-600',
  coverLabel: 'Checklists',
  icon: ClipboardCheckIcon,
  coverImage: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&h=600&fit=crop'
}, {
  title: 'Hoja de Práctica',
  subtitle: 'Seguimiento de ansiedad',
  value: '$12.00 USD',
  coverColor: 'bg-amber-600',
  valueColor: 'text-amber-600',
  coverLabel: 'Registro',
  icon: PenLineIcon,
  coverImage: 'https://images.unsplash.com/photo-1455390582262-044cdead277a?w=400&h=600&fit=crop'
}, {
  title: 'Plan Visual 24h',
  subtitle: 'Guía rápida de bolsillo',
  value: '$9.00 USD',
  coverColor: 'bg-purple-700',
  valueColor: 'text-purple-600',
  coverLabel: 'Pocket Plan',
  icon: ClockIcon,
  coverImage: 'https://images.unsplash.com/photo-1501139083538-0139583c060f?w=400&h=600&fit=crop'
}, {
  title: '10 Respuestas Clave',
  subtitle: 'Dudas resueltas',
  value: '$8.00 USD',
  coverColor: 'bg-rose-600',
  valueColor: 'text-rose-600',
  coverLabel: 'Guía FAQ',
  icon: HelpCircleIcon,
  coverImage: 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?w=400&h=600&fit=crop'
}];
export function OfferStack() {
  return <section className="w-full relative py-16 md:py-24 overflow-hidden" id="comprar" data-id="element-84">
      {/* Background: Sea view from countryside house */}
      <div className="absolute inset-0" data-id="element-85">
        <img src="https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=1600&h=900&fit=crop" alt="" className="w-full h-full object-cover" data-id="element-86" />
        <div className="absolute inset-0 bg-black/30" data-id="element-87" />
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          {/* Header */}
          <div className="text-center mb-10" data-id="element-90">
            <h2 className="font-lora text-3xl md:text-4xl font-bold text-white mb-2 drop-shadow-lg" data-id="element-91">
              Todo Lo Que Recibes Hoy
            </h2>
            <p className="font-inter text-white/70 italic drop-shadow" data-id="element-92">
              Acceso instantáneo en todos tus dispositivos
            </p>
          </div>

          {/* Marble table surface with books */}
          <div className="rounded-3xl p-8 md:p-12 relative overflow-hidden" style={{
          background: 'linear-gradient(135deg, #f5f0e8 0%, #e8e0d4 30%, #f2ede5 60%, #ddd5c9 100%)',
          boxShadow: '0 25px 60px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.6)'
        }} data-id="element-93">
            {/* Marble texture overlay */}
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: `url("https://images.unsplash.com/photo-1558618666-fcd25c85f82e?w=1200&h=800&fit=crop")`,
            backgroundSize: 'cover',
            mixBlendMode: 'multiply'
          }} data-id="element-94" />

            {/* Books layout: 3 top + 2 bottom centered, no gaps */}
            <div className="relative z-10" data-id="element-95">
              {/* Top row: 3 books */}
              <div className="flex flex-wrap justify-center gap-6 md:gap-8 mb-8" data-id="element-96">
                {offerItems.slice(0, 3).map((item, index) => <BookCard key={index} item={item} index={index} data-id="element-97" />)}
              </div>
              {/* Bottom row: 2 books centered */}
              <div className="flex flex-wrap justify-center gap-6 md:gap-8" data-id="element-98">
                {offerItems.slice(3).map((item, index) => <BookCard key={index + 3} item={item} index={index + 3} data-id="element-99" />)}
              </div>
            </div>
          </div>

          {/* Price Summary */}
          <div className="mt-10 bg-white/95 backdrop-blur-sm rounded-2xl p-8 text-center shadow-2xl" data-id="element-100">
            <div className="inline-block bg-gray-100 px-4 py-2 rounded-full text-charcoal/60 text-sm font-inter font-medium mb-4" data-id="element-101">
              Valor Total de la Colección:{' '}
              <span className="line-through" data-id="element-102">$93.00 USD</span>
            </div>

            <div className="mb-8" data-id="element-103">
              <span className="font-lora text-charcoal text-2xl font-light" data-id="element-104">
                Llévatelo todo hoy por solo
              </span>
              <div className="font-lora text-6xl font-black text-blue-700 tracking-tight" data-id="element-105">
                $7.18
              </div>
            </div>

            {/* CTA Button */}
            <motion.a href="https://vitalizateahora.com/cart/51977508520167:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto px-12 py-5 bg-blue-700 hover:bg-blue-800 text-white font-inter font-bold text-xl rounded-2xl shadow-xl uppercase tracking-wider transition-colors duration-200" whileHover={{
            scale: 1.03
          }} whileTap={{
            scale: 0.97
          }} data-id="element-106">
              SÍ, QUIERO MI PROTOCOLO AHORA
            </motion.a>

            <p className="mt-4 text-xs text-charcoal/40 font-inter flex items-center justify-center gap-2" data-id="element-107">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-108">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-109" />
              </svg>
              Pago seguro y acceso instantáneo
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}
function BookCard({
  item,
  index
}: {
  item: (typeof offerItems)[number];
  index: number;
}) {
  const IconComponent = item.icon;
  return <motion.div className="flex flex-col items-center" initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} data-id="element-110">
      {/* 3D Book */}
      <div className="relative mb-4" style={{
      perspective: '600px'
    }} data-id="element-111">
        <motion.div className="relative" style={{
        transformStyle: 'preserve-3d'
      }} whileHover={{
        rotateY: -12,
        scale: 1.06
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} data-id="element-112">
          {/* Book spine shadow */}
          <div className="absolute top-2 -left-1.5 w-4 h-full rounded-l-sm" style={{
          background: 'linear-gradient(to right, rgba(0,0,0,0.35), rgba(0,0,0,0.05))',
          transform: 'rotateY(30deg) translateZ(-5px)'
        }} data-id="element-113" />

          {/* Book cover */}
          <div className={`relative w-40 h-56 sm:w-44 sm:h-60 ${item.coverColor} rounded-r-lg rounded-l-sm overflow-hidden`} style={{
          boxShadow: '8px 8px 24px rgba(0,0,0,0.3), 2px 2px 6px rgba(0,0,0,0.15)'
        }} data-id="element-114">
            {/* Cover image */}
            <img src={item.coverImage} alt={item.title} className="absolute inset-0 w-full h-full object-cover opacity-50" data-id="element-115" />

            {/* Color overlay */}
            <div className={`absolute inset-0 ${item.coverColor} opacity-60`} data-id="element-116" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/30" data-id="element-117" />

            {/* Spine detail */}
            <div className="absolute left-0 top-0 w-2.5 h-full bg-black/25" data-id="element-118" />
            <div className="absolute left-0.5 top-0 w-px h-full bg-white/25" data-id="element-119" />
            <div className="absolute left-2 top-0 w-px h-full bg-white/10" data-id="element-120" />

            {/* Content */}
            <div className="relative z-10 flex h-full p-4 text-center flex-row items-center justify-center" data-id="element-121">
              {IconComponent ? <>
                  <div className="w-14 h-14 rounded-full bg-white/15 backdrop-blur-sm flex items-center justify-center mb-3" data-id="element-122">
                    <IconComponent className="h-8 w-8 text-white drop-shadow-lg" strokeWidth={1.5} data-id="element-123" />
                  </div>
                  <span className="text-white font-bold text-[10px] uppercase tracking-[0.25em] drop-shadow-lg" data-id="element-124">
                    {item.coverLabel}
                  </span>
                </> : <>
                  <div className="w-10 h-0.5 bg-white/40 rounded-full mb-3" data-id="element-125" />
                  <span className="text-white font-bold text-sm leading-tight uppercase tracking-[0.15em] drop-shadow-lg whitespace-pre-line" data-id="element-126">
                    {item.coverLabel}
                  </span>
                  <div className="w-10 h-0.5 bg-white/40 rounded-full mt-3" data-id="element-127" />
                </>}
            </div>

            {/* Page edges (right side) */}
            <div className="absolute right-0 top-2 bottom-2 w-1.5" data-id="element-128">
              <div className="w-full h-full bg-gradient-to-l from-gray-200 via-gray-100 to-gray-50 rounded-r-sm" data-id="element-129" />
            </div>
          </div>

          {/* Bottom page edges */}
          <div className="absolute -bottom-1 left-1.5 right-0 h-2 rounded-b-sm overflow-hidden" style={{
          transform: 'translateZ(-2px)'
        }} data-id="element-130">
            <div className="w-full h-full bg-gradient-to-b from-gray-50 via-gray-200 to-gray-300" data-id="element-131" />
          </div>
        </motion.div>
      </div>

      {/* Book Info */}
      <h3 className="font-inter font-bold text-charcoal text-sm mb-0.5 text-center drop-shadow-sm" data-id="element-132">
        {item.title}
      </h3>
      <p className="font-inter text-xs text-charcoal/60 mb-0.5 text-center" data-id="element-133">
        {item.subtitle}
      </p>
      <span className={`font-inter font-bold text-sm ${item.valueColor}`} data-id="element-134">
        {item.value}
      </span>
    </motion.div>;
}